import React, { Component } from 'react';
import { Grid, Cell, List, ListItem, ListItemContent } from 'react-mdl';
import PageShell from './PageShell';

class Contact extends Component {
    render() {
        return (
            <PageShell
                title="Contact"
                subtitle="Get in touch for solution design, architecture, and enterprise transformation engagements."
                className="page-contact"
            >
                <Grid className="contact-grid">
                    <Cell col={6} tablet={6} phone={12} className="contact-profile">
                        <h2>Joseph Johney</h2>
                        <img
                            src="https://s3-ap-southeast-2.amazonaws.com/portfoliobucket.joseph/myAvatar+(2).png"
                            alt="Joseph Johney"
                            className="contact-avatar"
                        />
                        <p className="contact-bio">
                            Senior technology leader specializing in solution design, enterprise architecture, and large-scale digital transformation programs across banking and financial services. Currently a Solution Designer at National Australia Bank (NAB), delivering secure and scalable platforms using AWS, Azure, Google Cloud, Apigee, Mulesoft, Salesforce, and microservices architectures. Recognized for stakeholder collaboration, solution ownership, and high-impact delivery in complex enterprise environments.
                        </p>
                    </Cell>
                    <Cell col={6} tablet={6} phone={12} className="contact-details">
                        <h2>Contact Me</h2>
                        <hr className="contact-divider" />
                        <div className="contact-list">
                            <List>
                                <ListItem>
                                    <ListItemContent className="contact-list-item">
                                        <i className="fa fa-phone-square" aria-hidden="true" />
                                        +61 439473163
                                    </ListItemContent>
                                </ListItem>
                                <ListItem>
                                    <ListItemContent className="contact-list-item">
                                        <i className="fa fa-envelope" aria-hidden="true" />
                                        josephjohney16@gmail.com
                                    </ListItemContent>
                                </ListItem>
                                <ListItem>
                                    <ListItemContent className="contact-list-item">
                                        <i className="fa fa-fax" aria-hidden="true" />
                                        +61 439473163
                                    </ListItemContent>
                                </ListItem>
                                <ListItem>
                                    <ListItemContent className="contact-list-item">
                                        <i className="fa fa-skype" aria-hidden="true" />
                                        josephjohney@outlook.com
                                    </ListItemContent>
                                </ListItem>
                            </List>
                        </div>
                    </Cell>
                </Grid>
            </PageShell>
        );
    }
}

export default Contact;
